import React from 'react';
import { motion } from 'framer-motion';
import { QrCode, Coins, Gamepad2, Trophy } from 'lucide-react';
const steps = [{
  icon: QrCode,
  title: 'Buy Tokens',
  desc: 'Grab tokens online or at the kiosk to start playing.',
  color: 'cyan' as const
}, {
  icon: Coins,
  title: 'Load Up Tokens',
  desc: 'Tap to add tokens at the kiosk — no quarters, no hassle.',
  color: 'purple' as const
}, {
  icon: Gamepad2,
  title: 'Work the Claw',
  desc: 'Pick your prize, line up the grip, and drop the claw to grab it.',
  color: 'pink' as const
}, {
  icon: Trophy,
  title: 'Win & Repeat',
  desc: 'Take home your plushie and keep chasing the rare prizes!',
  color: 'cyan' as const
}];
const ring: Record<'cyan' | 'purple' | 'pink', string> = {
  cyan: 'border-cyan-300 text-cyan-200 shadow-[0_0_20px_rgba(34,211,238,0.6)]',
  purple: 'border-purple-400 text-purple-200 shadow-[0_0_20px_rgba(168,85,247,0.6)]',
  pink: 'border-pink-400 text-pink-200 shadow-[0_0_20px_rgba(236,72,153,0.6)]'
};
export function HowItWorks() {
  return <section id="how-it-works" className="relative w-full py-20 sm:py-28" data-id="element-37">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-38">
        <div className="mb-14 text-center" data-id="element-39">
          <h2 className="font-arcade text-4xl sm:text-5xl" data-id="element-40">
            <span className="neon-purple" data-id="element-41">HOW TO</span>{' '}
            <span className="neon-cyan" data-id="element-42">PLAY</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl font-display text-purple-100/80" data-id="element-43">
            Four easy steps from walking in to winning big.
          </p>
        </div>

        <ol className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-44">
          {steps.map((s, i) => {
          const Icon = s.icon;
          return <motion.li key={s.title} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.45,
            delay: i * 0.1
          }} className="relative rounded-2xl border border-purple-500/30 bg-white/[0.03] p-6 text-center backdrop-blur-sm transition-colors hover:border-purple-400/60" data-id="element-45">
                <span className="absolute right-4 top-4 font-arcade text-3xl text-white/10" data-id="element-46">
                  {i + 1}
                </span>
                <div className={`mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full border-2 bg-[#05010f] ${ring[s.color]}`} data-id="element-47">
                  <Icon className="h-7 w-7" aria-hidden="true" data-id="element-48" />
                </div>
                <h3 className="font-display text-lg font-bold uppercase tracking-wide text-white" data-id="element-49">
                  {s.title}
                </h3>
                <p className="mt-2 font-display text-sm text-purple-100/75" data-id="element-50">
                  {s.desc}
                </p>
              </motion.li>;
        })}
        </ol>
      </div>
    </section>;
}